"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _dayjs = _interopRequireDefault(require("dayjs"));

var _elements = require("../../styles/elements");

var _FacebookMessenger = require("./FacebookMessenger.styles");

var _facebookMessenger = require("../../assets/icons/facebook-messenger");

var _phoneStatusBar = _interopRequireDefault(require("../../assets/images/phone-status-bar.png"));

var _Logo = _interopRequireDefault(require("./Logo/Logo"));

var _Bot = _interopRequireDefault(require("./Bot/Bot"));

var _MyMessage = _interopRequireDefault(require("./MyMessage/MyMessage"));

var _Message = _interopRequireDefault(require("./Message/Message"));

var FacebookMessenger = function FacebookMessenger(_ref) {
  var className = _ref.className,
      logo = _ref.logo,
      companyName = _ref.companyName,
      children = _ref.children;
  return (0, _jsxRuntime.jsxs)("div", {
    css: _FacebookMessenger.styles.base,
    className: className,
    children: [(0, _jsxRuntime.jsxs)("div", {
      className: "grui flex px-12 py-5",
      children: [(0, _jsxRuntime.jsx)("span", {
        css: _elements.text.styles.fontMedium,
        children: (0, _dayjs["default"])().format('h:mm')
      }), (0, _jsxRuntime.jsx)("div", {
        className: "grui ml-auto flex items-center",
        children: (0, _jsxRuntime.jsx)("img", {
          css: _FacebookMessenger.styles.statusBar,
          src: _phoneStatusBar["default"],
          alt: "phone status bar"
        })
      })]
    }), (0, _jsxRuntime.jsxs)("header", {
      css: _FacebookMessenger.styles.header,
      className: "grui p-5 pr-10",
      children: [(0, _jsxRuntime.jsx)(_facebookMessenger.Arrow, {
        className: "grui mr-5"
      }), (0, _jsxRuntime.jsxs)("div", {
        css: _FacebookMessenger.styles.companyInfo,
        children: [(0, _jsxRuntime.jsx)(_Logo["default"], {
          logo: logo,
          className: "grui mr-5"
        }), companyName]
      }), (0, _jsxRuntime.jsxs)("div", {
        css: _FacebookMessenger.styles.options,
        children: [(0, _jsxRuntime.jsx)(_facebookMessenger.Check, {}), (0, _jsxRuntime.jsx)(_facebookMessenger.Triangle, {})]
      })]
    }), (0, _jsxRuntime.jsx)("div", {
      css: _FacebookMessenger.styles.main,
      className: "grui pt-12 pb-5",
      children: children
    }), (0, _jsxRuntime.jsxs)("footer", {
      css: _FacebookMessenger.styles.footer,
      children: [(0, _jsxRuntime.jsx)(_facebookMessenger.Plus, {}), (0, _jsxRuntime.jsx)(_facebookMessenger.Camera, {}), (0, _jsxRuntime.jsx)(_facebookMessenger.Image, {}), (0, _jsxRuntime.jsx)(_facebookMessenger.Audio, {}), (0, _jsxRuntime.jsxs)("div", {
        className: "grui flex items-center flex-grow",
        children: [(0, _jsxRuntime.jsxs)("div", {
          css: _FacebookMessenger.styles.inputWrapper,
          children: [(0, _jsxRuntime.jsx)("input", {
            placeholder: "Aa",
            readOnly: true,
            css: _elements.input.styles.preflight
          }), (0, _jsxRuntime.jsx)(_facebookMessenger.Smile, {})]
        }), (0, _jsxRuntime.jsx)("div", {
          css: _FacebookMessenger.styles.like,
          className: "grui mr-4 ml-10",
          children: (0, _jsxRuntime.jsx)(_facebookMessenger.Like, {})
        })]
      })]
    })]
  });
};

FacebookMessenger.propTypes = {
  className: _propTypes.string,
  logo: _propTypes.string,
  companyName: _propTypes.string,
  children: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.node])
};
FacebookMessenger.defaultProps = {
  className: undefined,
  logo: undefined,
  companyName: undefined,
  children: undefined
};
FacebookMessenger.Message = _Message["default"];
FacebookMessenger.MyMessage = _MyMessage["default"];
FacebookMessenger.Logo = _Logo["default"];
FacebookMessenger.Bot = _Bot["default"];
var _default = FacebookMessenger;
exports["default"] = _default;
//# sourceMappingURL=FacebookMessenger.js.map